module.exports = __webpack_public_path__ + "img/2-2.82314ca9.png";